export default __webpack_public_path__ + "static/media/aave-logo.a65b714f.png";